<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" type="text" name="nombre" id="nommbre" rules="required" v-model="abonado.nombre" />
            </div>
            <div class="col-12">
                <FormInput label="Apellidos" type="text" name="apellidos" id="apellidos" rules="required" v-model="abonado.apellidos" />
            </div>
            <div class="col-12">
                <FormInput label="Dni" type="text" name="dni" id="dni" rules="required" v-model="abonado.dni" />
            </div>
            <div class="col-12">
                <FormInput label="Fecha de nacimiento" type="date" name="fecha_nacimiento" id="fecha_nacimiento" rules="required" min="1900-01-01" v-model="abonado.fecha_nacimiento" />
            </div>
            <div class="col-12">
                <FormInput label="Email" type="email" name="email" id="email" rules="required|email" v-model="abonado.email" />
            </div>
            <div class="col-12">
                <FormInput label="Teléfono" type="text" name="telefono" id="telefono" rules="required" v-model="abonado.telefono" />
            </div>
            <div class="col-12">
                <FormInput label="País" name="pais" id="pais" rules="required" v-model="abonado.pais" />
            </div>
            <div class="col-12">
                <FormInput label="Ciudad" name="ciudad" id="ciudad" rules="required" v-model="abonado.ciudad" />
            </div>
            <div class="col-12">
                <FormInput label="Dirección" name="direccion" id="direccon" rules="required" v-model="abonado.direccion" />
            </div>
            <div class="col-12">
                <FormInput label="CP/ZIP CODE" name="cp" id="cp" rules="required" minlength="5" maxlength="10" v-model="abonado.codigo_postal" />
            </div>
            <div class="col-12 text-right">
                <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            abonado: Object
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('submit');
                }
            }
        }
    }
</script>
